import { useSurchargeCodesOptional } from "@/context/SurchargeCodesContext";
import { cn } from "@/lib/utils";

import { HoverTooltip } from "./HoverTooltip";

interface SurchargeCodeProps {
  code: string;
  className?: string;
}

/**
 * Renders a surcharge code. When the code (or an alias of it) is in the
 * registry, hover shows the mapped display description.
 */
export function SurchargeCode({ code, className }: SurchargeCodeProps) {
  const ctx = useSurchargeCodesOptional();
  const description = ctx?.describe(code) ?? null;

  const inner = (
    <span
      className={cn(
        description &&
          "cursor-help underline decoration-dotted decoration-current/50 underline-offset-2",
        className,
      )}
      tabIndex={description ? 0 : undefined}
      aria-label={description ? `${code}: ${description}` : undefined}
    >
      {code}
    </span>
  );

  if (!description) return inner;

  return <HoverTooltip content={description}>{inner}</HoverTooltip>;
}
